import { render, staticRenderFns } from "./RecRL.vue?vue&type=template&id=772e9d44"
import script from "./RecRL.vue?vue&type=script&lang=js"
export * from "./RecRL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports